(() => {
  const bound = new WeakSet();
  const enhance = () => {
    document.querySelectorAll('.bcsell-product-name').forEach(name => {
      const card = name.closest('li');
      const title = name.textContent.trim();
      if (!card || !title) return;
      card.querySelectorAll('.bcsell-add-to-cart').forEach(control => {
        control.setAttribute('role', 'button');
        control.setAttribute('tabindex', '0');
        control.setAttribute('aria-label', control.textContent.trim() + ' — ' + title);
        if (!bound.has(control)) {
          bound.add(control);
          control.addEventListener('keydown', event => {
            if (event.key !== 'Enter' && event.key !== ' ') return;
            event.preventDefault();
            if (!event.repeat && control.getAttribute('aria-disabled') !== 'true') control.click();
          });
        }
      });
      card.querySelectorAll('select').forEach(select => {
        select.setAttribute('aria-label', title);
      });
      card.querySelectorAll('a').forEach(link => {
        if (link.querySelector('img')) link.setAttribute('aria-label', title);
      });
    });
  };
  let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; enhance(); });
  };
  enhance();
  new MutationObserver(schedule).observe(document.body, {childList: true, subtree: true});
})();